<div class="textbox" txtbClickOutside (clickOutside)="onClickOutside()">
  <div
    class="textbox-wrapper"
    tabindex="-1"
    [class.is-active]="this.isBoxActive"
    (cdkDragStarted)="onDragStart()"
    (cdkDragMoved)="onDragMove($event)"
    (cdkDragEnded)="onDragEnd()"
    [cdkDragBoundary]="'.notes-boundary'"
    cdkDrag
    #dragContainer
  >
    <div class="textbook-inner-wrapper">
      <p
        role="input"
        class="textbox-input"
        [class.is-disabled]="disabled"
        [spellcheck]="false"
        [style.color]="textColor"
        [style.--fontSize]="fontSize"
        (input)="onInput($event)"
        (keypress)="onInputKeypress($event)"
        (focusin)="onFocus()"
        (focusout)="onBlur()"
        [focusDelay]="200"
        [attr.contentEditable]="isOnline$ | async"
        inputmode="text"
        [textContent]="content"
        txtbAutofocusElem
        [blockAutofocus]="content.length > 0 || !isBoxActive"
        (mousedown)="$event.stopPropagation()"
        #textContentElement
      ></p>

      <ul class="tooltip" [style.--tooltipLeft]="tooltipLeft" cdkDragHandle>
        <li>
          <button type="button" (click)="remove($event)">
            <txtb-icons type="trashbin" class="trashbin-icon"></txtb-icons>
          </button>
        </li>
        <li>
          <button type="button" class="change-font-size" (click)="changeFontSize(1)">
            <txtb-icons type="fontBigger" class="font-bigger-icon"></txtb-icons>
          </button>
        </li>
        <li>
          <button type="button" class="change-font-size" (click)="changeFontSize(-1)">
            <txtb-icons type="fontSmaller" class="font-smaller-icon"></txtb-icons>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
